<div class="grid-wrapper">
    <div class="grid-row-1-col-1">
        <span style="color: #542A39; font-size: 14px; font-weight: bold; ">{{titleWeekFromTo}}</span>
        <app-week-selector (changeDate)="dateChanged($event)"></app-week-selector>
    </div>
</div>

<dx-data-grid class="pointer mat-elevation-z5" style="padding: 20px;margin-right:20px;margin-top:20px" [dataSource]="dataSource"
                [allowColumnResizing]="true"
                columnResizingMode="nextColumn"
                [rowAlternationEnabled]="true"
                [columnAutoWidth]="true"
                [columns]="columns"
                [summary]="summary">
  <dxo-group-panel [visible]="true"></dxo-group-panel>
  <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
  <dxo-paging [pageSize]="15"></dxo-paging>
  <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>
  <dxo-header-filter [visible]="true"></dxo-header-filter>
  <dxo-export [enabled]="true"></dxo-export>
  <dxo-sorting mode="multiple"></dxo-sorting>
  <dxo-column-chooser [enabled]="true" [title]="this.languageService.LNG('dxAllAms.dxDataGrid-columnChooserTitle')"></dxo-column-chooser>
  
</dx-data-grid>